import { Grid } from '@mui/material';
import BlockImage from 'components/layout/BlockImages/BlockImage/BlockImage';
import React, { useEffect, useState } from 'react';
import { ProductType } from 'types/product.types';
import { useIsScreenSizeMax } from 'utils/screen-size';

import { ProductImageCarousel } from '../index';

type ProductImagesProps = {
  product: ProductType;
};

const ProductImages = (props: ProductImagesProps) => {
  const { product } = props;
  const [activeImage, setActiveImage] = useState(product?.images?.[0]);

  const isMobile = useIsScreenSizeMax('md');

  // Set active image
  useEffect(() => {
    if (product && product.images) {
      product.images = product.images?.slice(0, 3);
      setActiveImage(product?.images?.[0]);
    }
  }, [product]);

  return (
    <>
      {/* MOBILE CAROUSEL */}

      {isMobile ? (
        <ProductImageCarousel product={product} responsiveCarousel={false} />
      ) : (
        <Grid container md={6} direction="column">
          <Grid container className="main-image-container">
            <BlockImage alt="" stretch={true} status={product.status} src={activeImage?.gallery} blurhash={activeImage?.blurHash} />
          </Grid>

          <Grid container spacing={2} className="alt-images-container pt-0">
            {product?.images
              ?.filter((img) => img.id !== activeImage.id)
              ?.map((img) => (
                <Grid xs={4} key={'alt-image-key-' + (img.title || img.thumbnail)}>
                  <BlockImage
                    alt=""
                    status={product.status}
                    showStatus={false}
                    src={img?.thumbnail}
                    blurhash={img?.blurHash}
                    stretch={true}
                    onClick={() => setActiveImage(img)}
                  />
                </Grid>
              ))}
          </Grid>
        </Grid>
      )}

      {/* DESKTOP */}
    </>
  );
};

export default ProductImages;
